import { t } from "@bezbolisno/i18n";
import { can } from "@bezbolisno/kit/rbac";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { LoadErrorScreen } from "../../../screens/invoices/shared";
import { PricingScreen } from "../../../screens/pricing/pricing-screen";
import { pricingBoardQuery } from "../../../screens/pricing/queries";

export const Route = createFileRoute("/_authed/pricing/")({
  beforeLoad: ({ context }) => {
    if (!can(context.session.role, "patient:read")) throw redirect({ to: "/" });
  },
  loader: ({ context }) => context.queryClient.ensureQueryData(pricingBoardQuery),
  errorComponent: () => <LoadErrorScreen title={t.pricing.title} />,
  component: () => {
    const { session } = Route.useRouteContext();
    return <PricingScreen userId={session.id} role={session.role} />;
  },
});
